import React, { useRef, useState, useCallback, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import {
	Button,
	Row,
	Col,
	FormGroup,
	Label,
	Input,
	Card,
	CardBody,
} from 'reactstrap';
import { PGMContext } from '~/context/PGMContext';
import CurrencyInput from 'react-currency-input';

import { ModalConfirmacaoSimples } from '~/views/Client/NovoLink/Modais/ConfirmacaoSimples';
import { symbolPriceFormatter } from '~/helpers/price';
import * as ActionsLinks from '~/store/modules/client/maquinaVirtual/actions';

import ReactGA from 'react-ga4';
import { PlanosContext } from '~/context/PlanosContext';
import { TextError } from '../styles';
import getValidationErrors from '../../../../utils/getValidationErrors';



function Simples() {
	const dispatch = useDispatch();
	const {
		getCupom,
	} = useContext(PGMContext);
	const { user } = useSelector((state) => state.auth);
	const formRef = useRef(null);

	const parcelasSemLink = [ '22x', '23x', '24x'];

	const [body, setBody] = useState({
		amount: '',
		amount_per_installment: 0,
		client_document: user.dados.documento,
		customer_choose_installment: false,
		installments: '',
		recurrence_type: null,
		recurrent_payment: false,
		title: '',
	});
	const [modal, setModal] = useState(false);

	const [bodyEmptyError, setBodyEmptyError] = useState({
		title: '',
		amount: '',
		installments: '',
	});

	const [arrayParcelas, setArrayParcelas] = useState([]);

	function handlerSelect(input) {
		const amount = body.amount.replace('.', '').replace(',', '.');
		setBody({
			...body,
			amount_per_installment:
				Math.round(amount * 100) / parseInt(input, 10),
			installments: Number(input),
		});
	}

	const toggleModal = useCallback(() => {
		setModal((oldState) => !oldState);
	}, []);

	const handleSubmit = useCallback(async () => {
		// string to float
		try {
			const schema = Yup.object().shape({
				title: Yup.string().required('Título obrigatório'),
				amount: Yup.string().required('Valor obrigatório'),
				installments: Yup.string().required('Parcelas obrigatórias'),
			});

			await schema.validate(body, {
				abortEarly: false,
			});

			const amount = body.amount.replace('.', '').replace(',', '.');

			const data = {
				amount: Math.round(amount * 100),
				amount_per_installment: body.amount_per_installment,
				customer_choose_installment: false,
				client_document: body.client_document,
				installments: body.installments,
				recurrence_type: null,
				recurrent_payment: false,
				title: body.title,
			};

			if(body.cupom){
				data.split_data = {
					customer_pgm: body.cupom
				}
			}
			dispatch(
				ActionsLinks.requestGerarLink(data, user)
			);
			toggleModal();
			handleClickLucreePorClickSimplesGA4();
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				setBodyEmptyError(errors);
			}
		}
	}, [body, dispatch, toggleModal]);

	function handleClickLucreePorClickSimplesGA4() {
		ReactGA.event({
			category: "lucree_por_click_simples_click",
			action: "Simples - Lucree por Click",
			label: "Acesso Lucree por Click, categoria Simples",
		});
	}

	const { getMaxParcelasByUser, authToken, maxParcelas } = useContext(PlanosContext);

	const initArrayPacelas = (numero = 12) => {
		const numeroReal = numero > 0 ? numero : 12;
		const parcelasList = [];

		for(let i = 1; i <= numeroReal; i++){
			if(!parcelasSemLink.includes(`${i}x`)){
				parcelasList.push({
					value: i,
					name: i === 1 ? `À vista` : `${i}x`
				})
			}

		}

		setArrayParcelas(parcelasList)
	}


	useEffect(() =>{
		initArrayPacelas();
		if (user.dados.documento && user.dados.gateway_token) {
			authToken().then((res) => {
				if(res.data.id_token){
					getCupom(user.dados.documento, res.data.id_token).then((response) => {
						if (response && response.status === 200) {
							setBody({...body, cupom: response.data.cupom_fiscal})
						}
					})
				}
			});
		}

		const fetch = async () =>{
			const getToken = await authToken();

			if(getToken.data.id_token){
				getMaxParcelasByUser(getToken.data.id_token);
			}

		}
		fetch();
	}, [])


	useEffect(() =>{
		initArrayPacelas(maxParcelas);
	}, [maxParcelas])



	return (
		<>
			<Form ref={formRef} onSubmit={handleSubmit}>
				<Card>
					<CardBody>
						<Row>
							<Col>
								<FormGroup>
									<Label>Título</Label>
									<Input
										type="text"
										placeholder="Dê um título ao seu link"
										onChange={(input) =>
											setBody({
												...body,
												title: input.target.value,
											})
										}
									/>
									{bodyEmptyError.title !== '' &&
										body.title === '' && (
											<TextError>
												Preencha o título antes de gerar
												o link
											</TextError>
										)}
								</FormGroup>
							</Col>
							<Col>
								<FormGroup>
									<Label>Valor</Label>
									<CurrencyInput
										type="text"
										className="form-control"
										placeholder="00,00"
										decimalSeparator=","
										thousandSeparator=""
										value={body.amount.toString()}
										onChangeEvent={(input) => {
											symbolPriceFormatter(
												setBody({
													...body,
													amount: input.target.value,
												})
											);
										}}
									/>
									{bodyEmptyError.amount !== '' &&
										body.amount === '' && (
											<TextError>
												Preencha o valor antes de gerar
												o link
											</TextError>
										)}
								</FormGroup>
							</Col>
							<Col>
								<FormGroup>
									<Label>Número de parcelas</Label>
									<Input
										type="select"
										onChange={(input) =>
											handlerSelect(input.target.value)
										}>
										<option value="">Selecione</option>
										{arrayParcelas.length > 0 && arrayParcelas.map((item, index) => (
											<option key={index} value={item.value}>
												{item.name}
											</option>
										))}
									</Input>
									{bodyEmptyError.installments !== '' &&
										(body.installments === '' ||
											body.installments === 0) && (
											<TextError>
												Selecione quantidade de parcelas
												antes de gerar o link
											</TextError>
										)}
								</FormGroup>
							</Col>
						</Row>
					</CardBody>
				</Card>
				<Row>
					<Col className="d-flex justify-content-end">
						<Button color="primary" type="submit">
							Gerar link
						</Button>
					</Col>
				</Row>
			</Form>
			<ModalConfirmacaoSimples toggle={toggleModal} isOpen={modal} />
		</>
	);
}

export default Simples;
